import api from '@/network';
import {
    chatMessageIndexInputAdapter,
    chatMessageSingleInputAdapter
} from "@/adapters/assessmentPlans/tasks/messages/chatMessageIndexInputAdapter";

export default {
    async sendMessage(
        planUuid: string,
        taskUuid: string,
        sessionUuid: string,
        payload: any,
        signal?: AbortSignal
    ) {
        let formData = new FormData();
        formData.append('uuid', payload.uuid);
        formData.append('message', payload.message);
        if(payload.deleting_files_uuid?.length) {
            payload.deleting_files_uuid.forEach((fileUuid, index) => {
                formData.append(`deleting_files_uuid[${index}]`, fileUuid);
            })
        }
        payload.files.forEach((file) => {
            formData.append('file[]', file);
        })

        const response = await api.post(
            `/plans/${ planUuid }/tests/${ taskUuid }/session/${ sessionUuid }/message`,
            formData,
            {
                signal
            }
        );
        return chatMessageSingleInputAdapter(response.data.data);
    },

    async getMessages(
        planUuid: string,
        taskUuid: string,
        sessionUuid: string,
        queryParams?: any
    ) {
        const response = await api.get(`/plans/${ planUuid }/tests/${ taskUuid }/session/${ sessionUuid }/chat`, {
            params: queryParams
        });
        response.data.data = chatMessageIndexInputAdapter(response.data.data)

        return response;
    },

    async deleteMessage(messageUuid: string) {
        const response = await api.delete(`/chat/message/${ messageUuid }`);

        return response?.data?.uid || false;
    },

}